import { BaseRedomElement } from "../../utils/base-redom-element.js";
import { DeliverySelectorStateManager } from "./delivery-selector-state-manager.js";
import { IDeliveryGroup } from "../../api/estore/checkout/interfaces/delivery-group-interface.js";
import { ICmsDeliverySelectorConfiguration } from "./interfaces/cms-delivery-selector-config-interface.js";
import { el } from "../../lib/redom.es.min.js";

export class DeliveryGroup extends BaseRedomElement {
    config: ICmsDeliverySelectorConfiguration;
    stateManager: DeliverySelectorStateManager;
    translations: any;
    group: IDeliveryGroup;
    root: Node;

    constructor(config: ICmsDeliverySelectorConfiguration, stateManager: DeliverySelectorStateManager, translations: any, group: IDeliveryGroup) {
        super(config.useShadowRoot);
        this.config = config;
        this.root = this.config.useShadowRoot ? this.shadowRoot : this;
        this.stateManager = stateManager;
        this.translations = translations;
        this.group = group;
        this.attachDelegates();
    }

    attachDelegates() {
        this.stateManager.selectedGroupDelegates
            .push((_, newGroupId) => {
                this.setSelected();
                
                if (this.group.id === newGroupId) {
                    this.setSelectedOptionInGroup();
                }
            });
        
        this.stateManager.selectedOptionDelegates.push((_, newOptionId) => {
            if (this.group.options.map(o => o.id).includes(newOptionId)) {
                this.group.lastSelectedOptionId = newOptionId;
            }
        })
    }

    connectedCallback() {
        this.render();
        this.setSelected();
    }

    render() {
        const d = this.group;

        const styles = this.config.useShadowRoot ? el("link", { rel: "stylesheet", href: this.config.cssFiles.groupItem}) : null;

        const els =
            el("a", {onclick: this.clicked.bind(this), href: "javascript:void(0)"},
                el("img", {width: this.config.groupIconWidth, src: d.iconUrl}),
                el("h3", d.title),
                d.description && el("p", d.description),
                el("footer",
                    el("div.price", d.price)
                )
            );

        this.mountArray(this.root, [styles, els]);
    }

    clicked(event: MouseEvent) {
        event.preventDefault();
        this.stateManager.setSelectedGroup(this.group.id);
    }

    setSelected() {
        if (this.group.selected) {
            this.classList.add("selected");
        } else {
            this.classList.remove("selected");
        }
    }

    setSelectedOptionInGroup(){
        if (this.group.options?.filter(o => o.selected).length === 0) {
            if (this.group.lastSelectedOptionId) {
                this.stateManager.setSelectedOption(this.group.lastSelectedOptionId);
            }
            else if (this.group.options && this.group.options.length > 0) {
                this.stateManager.setSelectedOption(this.group.options[0].id);
            }
        }
    }
}

customElements.define("delivery-group", DeliveryGroup);